module.exports = __webpack_public_path__ + "img/scroll-desktop.2160e5d9.jpg";